// CSV serialization for the §4c List "export loaded rows" affordance. Lives
// here, beside DataTable, because a screen whose export must sit in its own
// chrome row (the audit log's header action) builds its rows itself rather
// than through the table's toolbar — both paths share this one escaper.

/** RFC 4180 field escaping, with spreadsheet formula-injection neutralized:
 *  a leading = + - @ (or tab/CR variant) is executed as a formula by common
 *  spreadsheet apps, so such fields get a literal single-quote prefix (the
 *  standard OWASP CSV-injection mitigation) before quoting. */
export function escapeCsvField(field: string): string {
  const neutralized = /^[=+\-@\t\r]/.test(field) ? `'${field}` : field;
  if (/[",\r\n]/.test(neutralized)) {
    return `"${neutralized.replace(/"/g, '""')}"`;
  }
  return neutralized;
}

/** Rows (the first being the header) → an RFC 4180 document. */
export function toCsv(lines: readonly (readonly string[])[]): string {
  return lines
    .map((fields) => fields.map(escapeCsvField).join(","))
    .join("\r\n");
}

/** Hands the browser a CSV file built from `lines`. */
export function downloadCsv(
  fileName: string,
  lines: readonly (readonly string[])[],
): void {
  const blob = new Blob([toCsv(lines)], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  anchor.rel = "noopener";
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
